export const h1Bold = {
  fontFamily: 'Arial',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '120%',
};
